import initPipelineSchedulesApp from '~/ci/pipeline_schedules/mount_pipeline_schedules_app';

initPipelineSchedulesApp();
